import React from "react";
import { Modal, Button } from "react-bootstrap";

const STORAGE_KEY = "support_info_acknowledged";

class SupportInfoModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { checked: false };
  }

  handleConfirm = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    this.props.onClose();
  };

  render() {
    return (
      <Modal show={this.props.show} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>
            <i className="fa fa-headset mr-2"></i>
            Information importante concernant le support technique
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Le numéro du support technique est réservé exclusivement à
            l'assistance en cas de <strong>problèmes techniques</strong>{" "}
            rencontrés sur la plateforme (bug, erreur d'affichage, problème de
            connexion, etc.).
          </p>

          <p className="font-weight-bold mb-2">
            Merci de ne pas contacter le support pour :
          </p>
          <ul>
            <li>
              Les questions relatives à vos commandes (suivi, livraison, retard)
            </li>
            <li>
              Les demandes de renseignements sur les produits ou les tarifs
            </li>
            <li>Les questions administratives ou de facturation</li>
          </ul>
          <p className="text-muted">
            Pour ces sujets, veuillez vous adresser directement à{" "}
            <strong>{this.props.companyName || "votre prestataire habituel"}</strong>.
          </p>

          <div className="custom-control custom-checkbox mt-3">
            <input
              type="checkbox"
              className="custom-control-input"
              id="support-info-acknowledge"
              checked={this.state.checked}
              onChange={(e) => this.setState({ checked: e.target.checked })}
            />
            <label
              className="custom-control-label"
              htmlFor="support-info-acknowledge"
            >
              J'ai bien compris que le support technique est réservé aux
              problèmes liés à la plateforme
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={this.handleConfirm}
            disabled={!this.state.checked}
          >
            J'ai compris
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default SupportInfoModal;
